import { NgRedux } from '@ptl/angular-redux-store';
import { Pipe, PipeTransform } from '@angular/core';
import { StateStructure } from '@ptl/state';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PlanAttributes, SummaryView } from '../../interfaces/plan-attributes.interface';
import { Product } from '../../interfaces/product.interface';
import { PlanSummaryListPaginatorStateStructure } from '../configs/interfaces/plan-summary-list-paginator.state.interface';
import { PLAN_SUMMARY_LIST_PAGINATOR } from '../configs/plan-summary-list-paginator.reducer';

@Pipe({
    name: 'planSummaryListPaginator',
    pure: false,
    standalone: false
})
export class PlanSummaryListPaginatorPipe implements PipeTransform {

  constructor(
    private ngRedux: NgRedux<StateStructure>,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  transform(products: Product<PlanAttributes, SummaryView>[], ...args: unknown[]): unknown {

    if (!products) { return []; }

    const planSummaryListPaginator: PlanSummaryListPaginatorStateStructure
      = this.reducerUtilityService.getComponentStates()[PLAN_SUMMARY_LIST_PAGINATOR];

    const pageIndex = planSummaryListPaginator.pageIndex;
    const pageSize = planSummaryListPaginator.pageSize;

    if (pageIndex === undefined || !pageSize) {
      return products;
    }

    return products.filter((item, index) => {
      return (
        index < (pageIndex + 1) * pageSize &&
        index >= pageIndex * pageSize
      )
    });
  }

}
